'use client';

import { FC, useEffect, useState } from 'react';

import Cookies from 'js-cookie';

import { usePathname } from '@telialt/utils/src/pathname';

import { MaintenanceBanner as MaintenanceBannerModel, MaintenanceResponseData } from '../../model';
import { MaintenanceBanner } from './MaintenanceBanner';
import { getCookieMainDomain, getMaintenanceBannerCookieName } from './utils';

type Props = {
    data: MaintenanceResponseData;
};

export const Maintenance: FC<Props> = ({ data }) => {
    const maintenanceBanners = data?.maintenanceBanners;
    const pathname = usePathname();
    const [matchingBanner, setMatchingBanner] = useState<MaintenanceBannerModel | null>(null);

    const handleBannerClose = (cookieName: string, cookieExpiration: number) => {
        Cookies.set(getMaintenanceBannerCookieName(cookieName), 'true', {
            expires: cookieExpiration,
            path: '/',
            domain: getCookieMainDomain(),
        });
    };

    useEffect(() => {
        setMatchingBanner(
            maintenanceBanners?.find((banner) => {
                if (Cookies.get(getMaintenanceBannerCookieName(banner.cookieName))) {
                    return false;
                }

                if (!banner.urlPattern) {
                    return true;
                }

                return pathname?.startsWith(banner.urlPattern);
            }),
        );
    }, [maintenanceBanners, pathname]);

    if (!matchingBanner) {
        return null;
    }

    return <MaintenanceBanner data={matchingBanner} onClose={handleBannerClose} />;
};
